import axios from 'axios';
export const baseURL_DEV = 'https://api.giro.dev.thera.com.br:4433/'
export const baseURL_LOCAL = 'https://localhost:44370/'
export const baseURL_PROD = 'https://taz.metrorio.com.br/'
export const baseURL_HML  = 'https://tazhml.metrorio.com.br/';
export const baseURL = baseURL_PROD;
export const VERSION = "20260728";

const client = withoutHeaders => axios.create({
  baseURL: baseURL,
  timeout: 15000,
  headers: withoutHeaders ? {} : {"Authorization":`Bearer ${sessionStorage.getItem('giro-token')}`}
});

export default client; 